import React from 'react';
import { useEffect } from 'react';
import {
    CSSTransition
} from 'react-transition-group';
import { useState } from 'react';
import { sideMenuCSS } from './SideMenu.css';
import { RxCross2 } from 'react-icons/rx';

export const SideMenu = ({children, visible, setVisible}) => {
    const [insideVisible, setInsideVisible] = useState(false);

    useEffect(()=>{
        if(visible)
            document.body.style.overflowY = "hidden";
        else
            document.body.style.overflowY = "unset";
    }, [visible])

    useEffect(()=>{
     
            setInsideVisible(visible)
            

    }, [visible])

    return (
        <div css={sideMenuCSS()} >     
            <CSSTransition
                timeout={{
                    enter: 10,
                    exit: 300,
                }}
                classNames="SidebarContainer"
                in={visible}
                unmountOnExit
            > 
                <div
                    className='SidebarContainer'
                    onClick={(e)=>{setVisible(false)}}
                >
                    
                    <CSSTransition
                        timeout={{
                            enter: 40,
                            exit: 300,
                        }}
                        classNames="Sidebar"
                        in={insideVisible} unmountOnExit
                    >
                        <div 
                            className='Sidebar'
                            onClick={e => e.stopPropagation()}
                        >
                        <span className='TopSection'>
                            <RxCross2
                                className='ExitIcon' 
                                onClick={()=>setVisible(false)} />
                            {/* <i className="pi pi-times"
                                onClick={()=>setVisible(false)}
                                >
                            </i> */}
                        </span>
                        {children}
                        </div>
                    </CSSTransition>
                </div>
            </CSSTransition>
        </div>
    );
}
